export const access_token = process.env.REACT_APP_ACCESS_TOKEN;
export const refresh_token = process.env.REACT_APP_REFRESH_TOKEN;
export const api_urls_http = process.env.REACT_APP_API_URLS_HTTP;
export const api_urls_https = process.env.REACT_APP_API_URLS_HTTPS;
export const google_api_keys = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
export const google_translate_api_keys = process.env.REACT_APP_GOOGLE_TRANSLATE_API_KEY;
export const website_name = process.env.REACT_APP_WEBSITE_NAME;
export const support_email = process.env.REACT_APP_SUPPORT_MAIL;
export const zoom_sdk_key = process.env.REACT_APP_ZOOM_SDK_KEY;
export const kundli_key = process.env.REACT_APP_KUNDLI_KEY;
export const kundli_token = process.env.REACT_APP_KUNDLI_TOKEN;

export const current_year = new Date().getFullYear();